import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Sidebar = ({ collapsed = false, onToggleSidebar }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const userRole = localStorage.getItem("userRole");

    const isActive = (path) => location.pathname === path;

    const menuItems = [
        {
            section: t("menu.business"),
            items: [
                { label: t("menu.applications"), icon: "pi pi-file", path: "/crud/applications" },
                { label: t("menu.credits"), icon: "pi pi-wallet", path: "/crud/credits" },
                { label: t("menu.withholdings"), icon: "pi pi-percentage", path: "/crud/withholdings" },
                { label: t("menu.installments"), icon: "pi pi-calendar", path: "/crud/installments" },
            ],
        },
        {
            section: t("menu.users"),
            items: [
                { label: t("menu.administrators"), icon: "pi pi-shield", path: "/crud/administrators" },
                { label: t("menu.beneficiaries"), icon: "pi pi-users", path: "/crud/beneficiaries" },
                { label: t("menu.registrations"), icon: "pi pi-user-plus", path: "/crud/registrations" },
            ],
        },
        {
            section: t("menu.reports"),
            items: [
                { label: t("menu.reportWithholdingsByPeriod"), icon: "pi pi-file-export", path: "/reports/withholdings" },
            ],
        },
    ];

    if (userRole === "SuperUsers") {
        menuItems.push({
            section: "Sistema",
            items: [
                { label: t("menu.client"), icon: "pi pi-building", path: "/crud/clients" },
            ],
        });
    }

    return (
        <nav className="app-sidebar">
            <div className="sidebar-header">
                {!collapsed && (
                    <div className="sidebar-logo" onClick={() => navigate("/home")} style={{ cursor: "pointer" }}>
                        <img alt="Textum" src="/images/textum.svg" height="32" />
                    </div>
                )}
                <button
                    type="button"
                    className="sidebar-toggle"
                    onClick={onToggleSidebar}
                    title={collapsed ? "Expandir menú" : "Contraer menú"}
                >
                    <i className={`pi ${collapsed ? "pi-angle-right" : "pi-angle-left"}`}></i>
                </button>
            </div>

            <div className="sidebar-nav">
                {menuItems.map((group, gi) => (
                    <div key={gi}>
                        {!collapsed && <div className="sidebar-section-label">{group.section}</div>}
                        {group.items.map((item, ii) => (
                            <div
                                key={ii}
                                className={`sidebar-item${isActive(item.path) ? " active" : ""}`}
                                onClick={() => navigate(item.path)}
                                title={item.label}
                            >
                                <i className={item.icon}></i>
                                {!collapsed && <span>{item.label}</span>}
                            </div>
                        ))}
                    </div>
                ))}
            </div>

            <div className="sidebar-footer">
                <div className="sidebar-footer-item" onClick={() => navigate("/logout")} title={t("Logout")}>
                    <i className="pi pi-sign-out"></i>
                    {!collapsed && <span>{t("Logout")}</span>}
                </div>
            </div>
        </nav>
    );
};

export default Sidebar;
